/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { FormControl, FormLabel } from "@material-ui/core";
import confirm from "../../../components/DialogComponent/confirm";
import { addIssueResponse, updateBoldStatus } from "../../../services/apiservices/issues";
import FileUploadComponent from "../../../components/Fields/FileUploadComponent";
import AttachmentsView from "../../../components/AttachmentsView/AttachmentsView";
import AuthContext from "../../../hooks/authContext";
import CommonContext from "../../../hooks/commonContext";
import SingleSelectNew from "../../../components/SelectField/SingleSelectNew";
import { saveNotification2 } from "../../../services/apiservices/notifications";
import { cleanMessage, datetimest, packageAccess } from "../../../services/helpers";
import { StorageLimitAccess } from "../../../components/DialogComponent/SupplyDataDialog";
import { Textarea } from "../../../components/ui/textArea";
import { Input } from "../../../components/ui/input";
import { FilePlus2 } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { useMediaQuery } from "@mui/material";
import { useToast } from "../../../hooks/useToast";
import { trackEvent, CMS_EVENTS } from "../../../services/apiservices/analytics";

function EscalateForm(props) {
  const commonContext = useContext(CommonContext);
  const { userProfile } = useContext(AuthContext);
  const { issueId } = useParams();
  const history = useNavigate();
  const [escalated, setEscalated] = useState("");
  const [formData, setFormData] = useState({});
  const [alternativeData, setAlternativeData] = useState({});
  const [errors, setFormError] = useState({});
  const [attachments, setAttachments] = useState([]);
  const [email, setEmail] = useState("");
  const [clients, setClients] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [newClients, setNewClients] = useState([]);
  const [newEmployees, setNewEmployees] = useState([]);
  const [clientName, setClientName] = useState([]);
  const [employeeName, setEmployeeName] = useState([]);
  const [newClientName, setNewClientName] = useState([]);
  const [newEmployeeName, setNewEmployeeName] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width:767px)");
  const companyId =
    userProfile?.role === "companyUser"
      ? userProfile?.id
      : userProfile?.companyId;
  const userPackageId = userProfile?.prdId;
  const auth = useContext(AuthContext);
  const userPromocode = auth?.userProfile?.userPromoCode || auth?.userProfile?.companyData?.userPromoCode;
  const subscriptionId = auth?.userProfile?.subscriptionDetails?.scheduleId || auth?.userProfile?.subscriptions?.data?.[0]?.scheduleId;
  const allowedPermissions = packageAccess(userPackageId, userPromocode, subscriptionId);
  
  const { IssueDetail } = props;
  const { toast } = useToast();

  // const Emails = [
  //   "damon@procleanings.com",
  //   "hazel@procleanings.com",
  //   "nina@procleanings.com",
  // ];

  const usedEscalations = IssueDetail?.responses?.map(item => item?.escalated)?.filter(Boolean);

  const baseOptions = [
    { label: "None", value: "None" },
    { label: "Client Contacts", value: "Client Contact" },
    { label: "Internal Managers (Admins & Support)", value: "Internal Managers" },
    { label: "All Contacts (Client contacts, Internal managers)", value: "All Contacts" },
    { label: "Add Email (separate by commas,)", value: "Add Email" },
  ];
  const specialOptions = ["All Contacts", "Client Contact", "Internal Managers"];

  const clientUsed = usedEscalations?.includes("Client Contact");
  const internalUsed = usedEscalations?.includes("Internal Managers");
  const allUsed = usedEscalations?.includes("All Contacts");

  const disableAllThree = allUsed || (clientUsed && internalUsed);

  const filteredOptions = baseOptions?.map(option => {
    if (!specialOptions?.includes(option?.value)) return option;

    if (disableAllThree) return { ...option, disabled: true };

    if (clientUsed && option?.value === "Client Contact") return { ...option, disabled: true };
    if (internalUsed && option?.value === "Internal Managers") return { ...option, disabled: true };
    if (allUsed && option?.value === "All Contacts") return { ...option, disabled: true };

    return option;
  });

  const mapClientData = (client) => ({
    id: client.id,
    name: client.clientName,
    email: client.contact[0].email || "",
  });

  const mapEmployeeData = (employe) => ({
    id: employe.id,
    name: `${employe.firstName} ${employe.lastName}`,
    email: employe.email || "",
  });

  useEffect(() => {
    if (!IssueDetail) return;

    const mappedEmployees =
      IssueDetail?.employeeData?.map(mapEmployeeData) || [];
    const mappedClients = IssueDetail?.clientsDetails?.map(mapClientData) || [];

    const names = mappedClients?.map((client) => client.name);
    setClientName(names);
    const empName = mappedEmployees?.map((emp) => emp.name);
    setEmployeeName(empName);

    setEmployees(mappedEmployees);
    setClients(mappedClients);

    const { clients: matchingClients, employees: matchingEmployees } =
      getContacts(IssueDetail);

    const clientsData = matchingClients?.map((client) => client.name);
    setNewClientName(clientsData);
    const empData = matchingEmployees?.map((emp) => emp.name);
    setNewEmployeeName(empData);

    setNewEmployees(matchingEmployees);
    setNewClients(matchingClients);
  }, [IssueDetail]);

  const getContacts = (issueDetail) => {
    const clients = issueDetail?.clientsDetails || [];
    const employees = issueDetail?.AllEmpEmails || [];
    const emails = issueDetail?.email || [];

    const matchingClients = clients
      .filter((client) => emails?.includes(client.contact[0].email))
      .map(mapClientData);

    const matchingEmployees = employees
      .filter((employee) => emails?.includes(employee.email))
      .map(mapEmployeeData);

    return {
      clients: matchingClients,
      employees: matchingEmployees,
    };
  };

  const onClearData = () => {
    setFormData({});
    setAlternativeData({});
    setFormError({});
    setEscalated("");
    setAttachments([]);
    setEmail("");
    setEmployees([]);
    setClients([]);
    setNewEmployees([]);
    setNewClients([]);
    setClientName([]);
    setEmployeeName([]);
    setNewClientName([]);
    setNewEmployeeName([]);
  };

  const onCancel = async () => {
    await confirm("Are you sure you want to cancel this message?").then(
      () => {
        onClearData();
        history("/operations/issues/manage");
      },
      () => {
        console.log("cancel!");
      }
    );
  };

  const checkValid = () => {
    let errorMessages = errors;
    let isValid = true;

    if (
      typeof formData?.description === "undefined" ||
      formData?.description === ""
    ) {
      isValid = false;
      errorMessages = {
        ...errorMessages,
        description: "Field is required",
      };
    } else {
      errorMessages = { ...errorMessages, description: "" };
    }

    if (escalated === "Add Email" && email.trim() === "") {
      isValid = false;
      errorMessages = {
        ...errorMessages,
        email: "Email is required",
      };
    } else {
      errorMessages = { ...errorMessages, email: "" };
    }

    setFormError(errorMessages);
    return isValid;
  };

  const emailSend = () => {
    const ClientEmails = IssueDetail?.clientData || [];
    const EmployeeEmails = IssueDetail.newEmails?.map((emp) => emp.email) || [];
    const ValidEmail = [...ClientEmails, ...EmployeeEmails];

    let emailAddress = [];
    let recipients = [];

    switch (escalated) {
      case "None":
      case "":
        emailAddress = IssueDetail.finalEmailsData || [];
        recipients = [...newClientName, ...newEmployeeName];
        break;
      case "Client Contact":
        emailAddress = ClientEmails;
        recipients = clientName;
        break;
      case "Internal Managers":
        emailAddress = IssueDetail?.Emails;
        recipients = employeeName;
        break;
      case "All Contacts":
        emailAddress = [...ClientEmails, ...IssueDetail?.Emails];
        recipients = [...clientName, ...employeeName];
        break;
      case "Add Email":
        emailAddress = email
          ?.split(",")
          ?.map((email) => email?.trim())
          ?.filter((email) => {
            const matchedUser = IssueDetail?.newEmails?.find(
              (user) => user.email === email
            );
            if (!matchedUser) {
              return email;
            }
            if (matchedUser.status !== false && !matchedUser.deleted) {
              return email;
            }
            return null;
          })
          ?.filter((email) => email !== null);
        recipients = emailAddress;
        break;
      default:
        emailAddress = IssueDetail?.finalEmailsData || [];
        recipients = [];
    }

    if (IssueDetail?.finalEmailsData?.length) {
      emailAddress = [
        ...new Set([...emailAddress, ...IssueDetail?.finalEmailsData]),
      ];
      recipients = [
        ...new Set([...recipients, ...newClientName, ...newEmployeeName]),
      ];
    }

    const details = (formData.to = [...new Set(emailAddress)]);
    const UnMatchedEmail = details.filter(
      (emails) => !ValidEmail.includes(emails)
    );

    formData.recipients = [...new Set([...recipients, ...UnMatchedEmail])];

    if (IssueDetail.responses?.length > 0) {
      const latestResponse = IssueDetail.responses
        .slice()
        .sort((a, b) => b.respondOn - a.respondOn)[0];
      const descriptions = latestResponse?.escalated === "Respond from Email" ? latestResponse?.details : latestResponse?.description
      alternativeData.previousMessage = cleanMessage(descriptions || "").trim();
    }

    alternativeData.currentMessage = cleanMessage(formData.description).trim();

    formData.details = `New Message - Issue${String(IssueDetail.issueNumber.match(/\d+/)?.[0]).padStart(4, "0")}${IssueDetail.issueNumber.match(/\((.*?)\)/)?.[0] || ""} ${alternativeData.currentMessage}, Previous Message - Issue${String(IssueDetail.issueNumber.match(/\d+/)?.[0]).padStart(4, "0")}${IssueDetail.issueNumber.match(/\((.*?)\)/)?.[0] || ""} ${alternativeData.previousMessage}`;
  };

  const sendNotification = async () => {
    const { AllEmpEmails } = IssueDetail;

    const emailsArray = email.split(",").map((e) => e.trim());

    const emailObjects = emailsArray
      .map((email) => AllEmpEmails.find((emp) => emp?.email === email))
      .filter((emailObject) => emailObject && emailObject?.FCMToken);

    const details = emailObjects.map((emailObject) => ({
      id: emailObject?.id || "",
      name: `${emailObject?.firstName || ""} ${emailObject?.lastName || ""}`,
      email: emailObject?.email || "",
    }));

    let DataClient = [],
      DataEmployee = [],
      All = [];

    switch (escalated) {
      case "None":
      case "":
        DataClient = newClients;
        DataEmployee = newEmployees;
        break;
      case "Client Contact":
        DataClient = clients;
        DataEmployee = [];
        break;
      case "Internal Managers":
        DataClient = [];
        DataEmployee = employees;
        break;
      case "All Contacts":
        DataClient = clients;
        DataEmployee = employees;
        break;
      case "Add Email":
        DataClient = [];
        DataEmployee = details;
        break;
      default:
        DataClient = [];
        DataEmployee = [];
        break;
    }

    All = [...newClients, ...newEmployees];
    const combinedData = [...DataEmployee, ...DataClient, ...All];
    const uniqueData = Array.from(
      new Map(combinedData.map((item) => [item?.id, item])).values()
    );

    const notifications = [
      {
        Type: "PushNotification",
        Message:
          formData?.description?.length > 80
            ? `${formData?.description?.substring(0, 77)}...`
            : formData?.description,
        read: false,
        Employee: uniqueData,
        companyId: companyId,
        extData: { type: "Issue", id: IssueDetail?.id },
      },
    ];

    await saveNotification2(notifications);
  };

  const userData = IssueDetail?.newEmails?.filter(
    (item) => item?.id === userProfile?.id
  );

  const onResponse = async () => {
    if (!checkValid()) return;
    updateBoldStatus(issueId, userProfile?.id, IssueDetail?.employee?.id);

    try {
      const confirmResponse = await confirm(
        "Are you sure you want to respond to this issue?"
      );
      if (!confirmResponse) return;

      commonContext?.setLoader(true);

      const promises = [];

      if (escalated && escalated !== "None" && escalated !== "") {
        formData.escalated = escalated;
        promises.push(emailSend(), sendNotification());
      } else if (
        (!escalated || escalated === "None" || escalated === "") &&
        IssueDetail.escalated_to_admin === true
      ) {
        promises.push(emailSend(), sendNotification());
      }

      if (attachments?.length) {
        formData.attachments = attachments;
      }

      alternativeData.clientNames = clientName ? clientName[0] : null;

      alternativeData.publicPage = IssueDetail?.issueSettingRes?.[0]
        ? IssueDetail?.issueSettingRes?.[0]?.publicPageType
        : "No";

      const respondBy = {
        id: userProfile.id,
        name: `${userProfile.firstName} ${userProfile.lastName}`,
      };
      const companyName = `${auth?.userProfile?.companyData?.data?.companyName}`

      await Promise.all(promises);

      await addIssueResponse(
        IssueDetail?.id,
        formData,
        respondBy,
        IssueDetail?.issueNumber,
        alternativeData,
        IssueDetail?.newEmails,
        companyId,
        companyName,
        (res) => {
          if (escalated && escalated !== "None" && escalated !== "") {
            trackEvent(CMS_EVENTS.ISSUE_ESCALATED, {
              issue_id: IssueDetail?.id,
              issue_number: IssueDetail?.issueNumber,
              escalation_level: escalated
            });
          }
          onClearData();
          props.fetchIssuesDetails();
          toast?.({ title: "Success", description: "Comment Added Successfully" });
          commonContext?.setLoader(false);
        },
        (error) => {
          console.log("error", error);
          commonContext?.setLoader(false);
        }
      );
    } catch (error) {
      console.log("error", error);
      commonContext?.setLoader(false);
    }
  };

  const onChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setFormError({ ...errors, [name]: "" });
  };

  const onChangeInputEscalated = (value) => {
    setEscalated(value);

    if (value === "None" || value.trim() === "" || value !== "Add Email") {
      setEmail("");
    }

    if (value === "None" || value.trim() === "") {
      setFormData({ ...formData, escalatedTo: "" });
    } else {
      setFormData({ ...formData, escalatedTo: "Escalate" });
    }
  };

  const onFileUpload = async (files) => {
    const extraLimit = auth?.userProfile?.additionalQuantity * 5;
    const extraLimitInBytes = extraLimit * 1024 ** 3;
    const storageLimit =
      (allowedPermissions?.storageLimits ?? 0) + extraLimitInBytes;

    let validFiles = [];

    files?.forEach((file) => {
      if (userProfile?.storage + file.size > storageLimit) {
        setDialogOpen(true);
      } else {
        validFiles.push(file);
      }
    });

    setAttachments((prevAttachments) => {
      const newAttachments = [...prevAttachments, ...validFiles];
      if (newAttachments.length > 5) {
        return prevAttachments;
      }
      return newAttachments;
    });
  };

  const handleDelete = (fileToDelete) => {
    setAttachments((prevAttachments) => {
      return prevAttachments.filter((file) => file !== fileToDelete);
    });
  };

  // function validateEmail(email) {
  //   const re =
  //     /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(,\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})*$/;
  //   return re.test(email);
  // }

  function validateEmail(emailList) {
    const emails = emailList.split(",").map((e) => e.trim());
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const invalidSequenceRegex = /[\/]{1}|\.{2,}|\/\.|\.\/|[^a-zA-Z0-9._%+-@]/;

    const errors = [];

    for (let email of emails) {
      if (!emailRegex.test(email)) {
        errors.push(`Invalid format: ${email}`);
      } else if (invalidSequenceRegex.test(email)) {
        errors.push(`Invalid characters in: ${email}`);
      }
    }

    return errors;
  }

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  // const shouldRenderEscalate =
  //   !IssueDetail?.issueSettingRes?.[0] ||
  //   IssueDetail?.issueSettingRes?.[0]?.escalateRequestRole?.includes(
  //     userProfile?.role
  //   );

  return (
    <>
      <div className="issueDetails mb-20 formtxtbtm">
        <div className="mv-20">
          <Textarea
            placeholder="Add your comment here..."
            className="min-h-[120px] mb-3 focus-visible:ring-purple-500"
            name="description"
            value={formData?.description || ""}
            onChange={onChangeInput}
            disabled={userData?.[0]?.status === false}
          />
          {errors?.description && (
            <span className="small error color-danger">
              {errors?.description}
            </span>
          )}
        </div>
        {/* {shouldRenderEscalate && ( */}
        <div className="d-flex flex-center delete">
          <div className="wNew-50 d-flex flex-center delete">
            <span className="fw-bold w-30">Escalate Issues?</span>
            <SingleSelectNew
              placeholder="Escalate Issues?"
              value={escalated || ""}
              name={"Escalate Issues?"}
              contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
              itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
              onChange={onChangeInputEscalated}
              options={filteredOptions}
            />
          </div>
          {escalated === "Add Email" && (
            <div className="w-90">
              <Input
                name="email"
                value={email}
                className={isMobile ? "w-100 mt-15" : "w-100 ml-15"}
                onChange={(e) => {
                  const emailValue = e.target.value;
                  setEmail(emailValue);

                  if (!emailValue.trim()) {
                    setFormError((prev) => ({ ...prev, email: [] }));
                  } else {
                    const errorMessages = validateEmail(emailValue);
                    setFormError((prev) => ({ ...prev, email: errorMessages }));
                  }
                }}
                variant="outlined"
                error={errors?.email?.length > 0}
              />

              {errors?.email?.length > 0 && (
                <div className="mt-4">
                  {errors?.email?.map((err, idx) => (
                    <div key={idx} className="small error color-danger">
                      {err}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
        {/* )} */}
        <div className="mb-20 mt-10 d-flex flex-space-between flex-center">
          <FormControl fullWidth className="mv-15">
            <FormLabel className="mr-20 mb-5 strong dark:text-white">Attachments</FormLabel>
            <AttachmentsView
              attachments={attachments}
              onDelete={handleDelete}
            />
            <FileUploadComponent
              attachments={attachments}
              onuploadfile={onFileUpload}
              buttonText={
                <span className="d-flex flex-center">
                  <FilePlus2 className="h-4 w-4 mr-4" /> Attach Files
                </span>
              }
            />
          </FormControl>
          <div
            className="d-flex"
            style={{ width: isMobile ? "200px" : "300px" }}
          >
            <Button
              className="bg-purple-600 hover:bg-purple-700 color-white mr-15"
              onClick={onResponse}
            >
              Add Comment
            </Button>
            <Button variant="outline" className="mr-15" onClick={onCancel}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
      {dialogOpen && (
        <StorageLimitAccess
          open={dialogOpen}
          onClose={handleDialogClose}
          auth={auth}
        />
      )}
    </>
  );
}

export default EscalateForm;
